module.exports = __webpack_public_path__ + "static/img/applyImg3.5cc505e0.png";